<title>{{ sandboxPage.htmlTitle }}</title>
<app-banner [banner]="sandboxPage.banner" [isDefaultPageBanner]="true"></app-banner>
<div *ngIf="SandboxMaintenanceLabels.SandboxMaintenanceAlert" class="SandboxMaintenanceAlert">
  <div class="warning">
  {{ SandboxMaintenanceLabels.SandboxMessages }}
</div>
</div>
<div class="mainSandboxPage bg-image">
  <div class="tabSandbox" [class]="widthAdjust">
    <ul>
      <li>
        <button [class.active]="activeSideMenu === 'findOrder'" (click)="tabChange('findOrder')"><i
            class="baIcn ba-manage-order ba-2x"></i></button>
      </li>
      <li>
        <button [class.active]="activeSideMenu === 'searchOffer'" (click)="tabChange('searchOffer')"><i
            class="fa fa-plane"></i></button>
      </li>
      <li>
        <button [disabled]="disableOfferFilter" [class.active]="activeSideMenu === 'filterOffer'"
          (click)="tabChange('filterOffer')">
          <i class="fas fa-filter"></i>
        </button>
      </li>
      <li>
        <button [class.active]="activeSideMenu === 'ocnNotification'" class="posRelative"
          (click)="tabChange('ocnNotification')">
          <i class="fa fa-exclamation-triangle"></i>
          <span class="disruptCount">{{ distruptedPnrCount }}</span>
        </button>
      </li>
      <li>
        <button [class.active]="activeSideMenu === 'orderDetails'" (click)="tabChange('orderDetails')"><i
            class="fa fa-ticket-alt" aria-hidden="true"></i></button>
      </li>
      <li>
        <button [class.active]="activeSideMenu === 'log'" (click)="tabChange('log')"><i
            class="fa fa-file-code"></i></button>
      </li>
      <li>
        <button [class.active]="activeSideMenu === 'settings'" (click)="tabChange('settings')"><i
            class="fa fa-cog"></i></button>
      </li>
    </ul>
    <div class="tabSandboxContent" *ngIf="activeSideMenu === 'findOrder' && hideSideMenu === 'No'">
      <app-find-order-screen></app-find-order-screen>
    </div>
    <div class="tabSandboxContent" *ngIf="activeSideMenu === 'searchOffer' && hideSideMenu === 'No'">
      <app-search-flights-screen></app-search-flights-screen>
    </div>
    <div class="tabSandboxContent" *ngIf="activeSideMenu === 'filterOffer' && hideSideMenu === 'No'">
      <app-filter-offers-screen></app-filter-offers-screen>
    </div>
    <div class="tabSandboxContent" *ngIf="activeSideMenu === 'ocnNotification' && hideSideMenu === 'No'">
      <app-disrupted-order-viewer-screen></app-disrupted-order-viewer-screen>
      <!-- disrupted -->
    </div>
    <div class="tabSandboxContent" *ngIf="activeSideMenu === 'orderDetails' && hideSideMenu === 'No'">
      <app-order-details-screen></app-order-details-screen>
    </div>
    <div class="tabSandboxContent" *ngIf="activeSideMenu === 'log' && hideSideMenu === 'No'">
      <app-xml-logs-screen></app-xml-logs-screen>
    </div>
    <div class="tabSandboxContent" *ngIf="activeSideMenu === 'settings' && hideSideMenu === 'No'">
      <app-api-connection-profile-screen></app-api-connection-profile-screen>
    </div>
  </div>
  <div class="">
    <!--<div [class]='eleAbsoluteClass' *ngIf="hasAirlineOffersScreenData() && (disaplyOfferPriceScreen || hideOfferPriceScreen)" class="airlineOffersScreen overflowDiv hidescreen" id="airlineOffersScreenDiv">-->
    <div *ngIf="activeMainMenu === 'disrupted-offers'" class="airlineOffersScreen overflowDiv">
      <app-disrupted-order-viewer-screen></app-disrupted-order-viewer-screen>
    </div>

    <div *ngIf="activeMainMenu === 'airline-offers'" class="airlineOffersScreen overflowDiv">
      <app-airline-offers-screen> </app-airline-offers-screen>
    </div>

    <div *ngIf="activeMainMenu === 'offer-price'" class="offerPriceScreen overflowDiv hidescreen"
      id="offerPriceScreenDiv">
      <app-offer-price-screen></app-offer-price-screen>
    </div>

    <div *ngIf="activeMainMenu === 'your-booking-screen'" class="overflowDiv" id="yourBookingScreenDiv">
      <app-your-booking-screen></app-your-booking-screen>
    </div>

    <div *ngIf="activeMainMenu === 'add-ancilliaries-screen'" class="overflowDiv" id="addAancilliariesScreenDiv">
      <app-add-ancilliaries-screen></app-add-ancilliaries-screen>
    </div>
    <div *ngIf="activeMainMenu === 'add-baggage'" class="overflowDiv">
      <app-add-baggage-screen></app-add-baggage-screen>
    </div>
    <div *ngIf="activeMainMenu === 'seat-selection'" class="overflowDiv hidescreen">
      <app-seat-selection-screen></app-seat-selection-screen>
    </div>
    <div *ngIf="activeMainMenu === 'passenger-details'" class="overflowDiv hidescreen">
      <app-passenger-details-screen></app-passenger-details-screen>
    </div>
    <div *ngIf="activeMainMenu === 'change-date-time-screen'" class="overflowDiv hidescreen">
      <app-change-flight-date-time></app-change-flight-date-time>
    </div>
    <div *ngIf="activeMainMenu === 'passenger-name-change'" class="overflowDiv hidescreen">
      <app-passenger-name-change-screen></app-passenger-name-change-screen>
    </div>
    <div *ngIf="activeMainMenu === 'split-booking'" class="overflowDiv hidescreen">
      <app-split-booking-screen></app-split-booking-screen>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<!--Error Section-->
<!-- <ng-template [ngIf]="showError === 'Yes' "> -->

<ng-template [ngIf]="showError === 'Yes'">
  <div id="errorpn" style="display: block">
    <div class="pnclose">
      <a href="#" (click)="removeErrorSection()"><i class="fa fa-times-circle fa1x"></i></a>
    </div>

    <div id="errDet" class="err flexTop">
      <i class="fa fa-exclamation-triangle fa-lg mt-2 me-2"></i>
      <span [innerHTML]="errorMessage | mdToHtml"></span>
    </div>
  </div>
</ng-template>
<!--end-->
<!--Warning Section-->
<ng-template [ngIf]="showWarning === 'Yes'">
  <div id="warningpn" style="display: block">
    <div class="pnclose">
      <a href="#" (click)="removeWarningSection()"><i class="fa fa-times-circle fa1x"></i></a>
    </div>
    <div id="errDet" class="warning flexTop">
      <i class="fa fa-exclamation-triangle fa-lg mt-2 me-2"></i>
      <span [innerHTML]="warningMessage | mdToHtml"></span>
    </div>
  </div>
</ng-template>
<!--end-->

<!--Success Section-->
<ng-template [ngIf]="showSuccess === 'Yes'">
  <div id="successpn" class="success-msg-box" style="display: block">
    <div class="pnclose">
      <a href="#" (click)="removeSuccessSection()"><i class="fa fa-times-circle fa1x"></i></a>
    </div>
    <div id="errDet" class="success-msg-bg">
      <i class="fa fa-check fa-lg"></i>
      {{ successMessage }}
    </div>
  </div>
</ng-template>
<!--end-->

<!-- Modal -->
<div class="modal cancelPopup" id="disruptBookingPopup" tabindex="-1" role="dialog" aria-hidden="true"
  aria-labelledby="disruptBookingPopupTitle">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">DISRUPT BOOKING!</h5>
        <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">Confirm to disrupt this Booking!</div>
      <div class="modal-footer">
        <div class="jconfirm-buttons">
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-default"
            (click)="disruptPNR()">confirm</button>
          <button type="button" data-bs-dismiss="modal" aria-label="Close" class="btn btn-default">cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- cancel held booking -->
<div class="row">
  <div class="col-sm-12">
    <div class="modal cancelPopup" id="CancelHeldBookingPopup" tabindex="-1" role="dialog"
      aria-labelledby="disruptBookingPopupTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">CANCEL BOOKING ?</h5>
            <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">Confirm Cancel this Flight</div>
          <div class="modal-footer">
            <button type="button" class="grayBtn" data-bs-dismiss="modal" (click)="displayCancelError()"
              aria-label="Close">Yes</button>
            <button type="button" class="grayBtn" data-bs-dismiss="modal" aria-label="Close">No</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- cancel held booking -->

<!-- OCN MOdal -->

<div class="modal fade" id="ocnModal" tabindex="-1" role="dialog" aria-labelledby="ocnModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ocnModalTitle">Confirm To Move</h5>
        <button type="button" class="btn-close close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">Confirm to Move the selected Items in to Archive</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="moveToArchive()" data-bs-dismiss="modal">Confirm</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade in featureGuide" id="featureGuide" tabindex="-1" role="dialog" aria-labelledby="ocnModalTitle"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div>
        <div class="modal-header">
          <h5 class="modal-title" id="ocnModalTitle">Newly added Features</h5>
        </div>
        <div class="modal-body">
          <div>
            <button id="previous" class="slick-prev slick-arrow"></button>
            <button id="next" class="slick-next slick-arrow"></button>
          </div>
          <ul class="slides_container" id="slides">
            <li class="featureSlide toggle" *ngFor="let newFeature of newFeatures.newfeatureSectionCard">
              <h5>{{ newFeature.title }}</h5>
              <div [innerHtml]="returnHtmlFromRichText(newFeature.richTextBody) || '' | mdToHtml"></div>
              <img src="{{ newFeature.headImage }}" />
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
            (click)="updateGuideVisit('addOfferFeature')">Close</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
            (click)="updateGuideVisit('addOfferFeature')">Skip</button>
        </div>
      </div>
    </div>
  </div>
</div>
